import { store } from '@/firebase'
import {
  CollectionName,
  FSUserFreeFeatureToggles
} from '@WombatTechnology/nitte-time-lib'
import {
  collection,
  CollectionReference,
  doc,
  DocumentReference
} from 'firebase/firestore'

export class UserFreeFeatureToggle {
  static doc(uid: string): DocumentReference<FSUserFreeFeatureToggles> {
    return doc(this.collection(), uid)
  }

  static collection() {
    return collection(
      store,
      `${CollectionName.UserFreeFeatureToggles}`
    ) as CollectionReference<FSUserFreeFeatureToggles>
  }
}
